import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React from 'react';
import axios from 'src/utils/axios';
import { useTranslation } from 'react-i18next';

function ProductWorkCaseSearch({ setProduct, value, disabled, searchParam, error }) {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const loading = open && options.length === 0;
  const [search, setSearch] = React.useState('');
  const { t } = useTranslation('overview');
  const [loadingText, setLoadingText] = React.useState(t('lblSearchText'));
  React.useEffect(() => {
    let active = true;
    if (open) {
      if (search.length > 0) {
        axios
          .get(
            `/GetProductWorkCaseSearch/${(search || ' ')
              .toString()
              .toLocaleLowerCase(localStorage.i18nextLng_normalized)}`
          )
          .then(res => {
            if (active) {
              if (res.data) {
                setOptions(res.data);
              } else {
                setLoadingText(t('lblText'));
                setOptions([]);
              }
            }
          })
          .catch(err => {
            setOptions([]);
          });
      }
    }
    return () => {
      active = false;
    };
  }, [search, open, loading]);

  React.useEffect(() => {
    if (searchParam.length > 0) {
      setSearch(searchParam);
    }
  }, [searchParam]);

  const updateProduct = item => {
    console.log(item);
    setProduct(item);
    value.Dsc = item.Dsc;
    value.Id = item.Id;
  };

  return (
    <Autocomplete
      id="asynchronous-demo"
      open={open}
      size="small"
      value={value}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      getOptionLabel={option => {
        return option.Dsc;
      }}
      options={options}
      filterOptions={(options, state) => options}
      loading={loading}
      loadingText={loadingText}
      onChange={(event, newValue) => {
        if (newValue && newValue.Dsc) {
          updateProduct(newValue);
        } else {
          updateProduct([{ Dsc: '', Id: 0 }]);
        }
      }}
      disabled={disabled}
      renderInput={params => (
        <TextField
          {...params}
          fullWidth
          label={t('lblNewProduct')}
          size="small"
          required
          error={error}
          onChange={e => setSearch(e.target.value)}
          variant="outlined"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading}
                {params.InputProps.endAdornment}
              </>
            )
          }}
        />
      )}
    />
  );
}

export default ProductWorkCaseSearch;
